import { Link } from 'react-router-dom';

const quickLinks = [
  { name: '明星塌房', slug: 'star-collapse', icon: 'ri-alert-line' },
  { name: '网红黑料', slug: 'wanghong-expose', icon: 'ri-eye-off-line' },
  { name: '每日大赛', slug: 'daily-contest', icon: 'ri-fire-line' },
  { name: '吃瓜视频', slug: 'video-gossip', icon: 'ri-vidicon-line' },
  { name: '独家爆料', slug: 'exclusive-reveal', icon: 'ri-spy-line' },
  { name: '黑料追踪', slug: 'hot-tracking', icon: 'ri-radar-line' },
];

const stripImages = [
  'https://readdy.ai/api/search-image?query=Entertainment%20gossip%20news%20collage%20with%20dramatic%20red%20and%20black%20aesthetic%2C%20breaking%20news%20headline%20style%2C%20modern%20editorial%20design&width=600&height=400&seq=cta-strip-01&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Celebrity%20scandal%20newspaper%20headlines%20with%20paparazzi%20photo%20composition%2C%20dramatic%20lighting%2C%20dark%20cinematic%20atmosphere%2C%20news%20media%20collage&width=600&height=400&seq=cta-strip-02&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Viral%20social%20media%20posts%20collection%20with%20trending%20hashtags%2C%20smartphone%20screen%20glow%20in%20dark%20background%2C%20digital%20age%20gossip%20culture&width=600&height=400&seq=cta-strip-03&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Entertainment%20industry%20behind%20the%20scenes%20with%20camera%20equipment%20and%20spotlight%2C%20moody%20dark%20atmosphere%2C%20cinematic%20production%20aesthetic&width=600&height=400&seq=cta-strip-04&orientation=landscape',
  'https://readdy.ai/api/search-image?query=Red%20carpet%20event%20with%20flashing%20cameras%20and%20crowd%20excitement%2C%20dramatic%20spotlight%20effect%2C%20celebrity%20culture%20atmosphere%2C%20high%20energy%20scene&width=600&height=400&seq=cta-strip-05&orientation=landscape',
];

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-[1280px] px-6 md:px-10 text-center">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-foreground-950">
          吃瓜不等待，现在就上车
        </h2>
        <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
          全网最全吃瓜资源一站聚合，最新爆料实时推送
        </p>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          {quickLinks.map((link) => (
            <Link
              key={link.slug}
              to={`/category/${link.slug}`}
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-white rounded-full text-sm font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
            >
              <i className={`${link.icon}`}></i>
              {link.name}
            </Link>
          ))}
        </div>

        <div className="mt-14 overflow-hidden">
          <div className="flex gap-4" style={{ animation: 'scroll-strip 20s linear infinite' }}>
            {[...stripImages, ...stripImages].map((url, i) => (
              <div key={i} className="flex-shrink-0 w-[240px] h-[160px] md:w-[300px] md:h-[200px] rounded-xl overflow-hidden">
                <img
                  src={url}
                  alt="吃瓜热点"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}